import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import {
    CDropdown,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
    CImg,
  } from "@coreui/react";
import Lottie from 'react-lottie-player'
import lottieJson from 'src/views/annimation/Arrow-Triplet.json'
import lottieJson2 from 'src/views/annimation/Arrow-Triplet-red.json'
import './dashboard360.css'
import {
  TheContent,
  TheSidebar,
  TheFooter,
  TheHeader
} from '../../containers/index'
import {
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CDataTable,
    CBadge,
    CForm,
    CFormGroup,
    CFormText,
    CInput,
    CInputFile,
    CInputRadio,
    CLabel,
    CSelect,
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CTabContent,
    CTabPane,
    CTabs,
} from '@coreui/react'

import CIcon from '@coreui/icons-react'
import API from 'src/utils/apiCalling';
import { config } from 'src/utils/apiUrl';
import MyInfoTopSection from 'src/views/my_info/My_info_top_section';
import UserInfoDoc from 'src/HR-PANEL/offer_accept/user_info_doc';


const HeadcountDashboard = () => {

    const api = new API()
    const [userPersonalInfo, setUserPersonalInfo] = useState();
    const [candidateFullDocumentDetails, setCandidateFullDocumentDetails] = useState()

    useEffect(() => {
        userInfo()
        getDocumentDetails()
        let i;
        for (i = 0; i < 10; i++) {
            if (i == 3) {
                continue
            }
            if(true) {
                // console.log("inside second true", i)
            }
            // console.log("priting", i)
        }
    }, [])
    const userInfo = async () => {
        // console.log("inside user profile")

        let result = await api.get(config.profile)
        if (result && result.data && result.data.length>0) {
            setUserPersonalInfo(result.data[0])
            // console.log("user basic info>>>>>>>>>>>>>>>>>>>>>.", result.data[0])
        }
    }

    const getDocumentDetails = async () => {
        let data = {
            // candidate_email: "",
            // candidate_email: "yogesh.mathur@qdegrees.com"
        }
        let result = await api.get(config.getEmployeeAllPersonalDetails, true, data)
        if (result && result.code == 200) {
            setCandidateFullDocumentDetails(result.data)
        } else {
            // console.log("unable to get document details")
        }
    }
    return (
        <>
         <div className="c-app c-default-layout">
      <TheSidebar />
      <div className="c-wrapper">
        <TheHeader />

        <div className="c-body">
  <main className='c-main'>
  <CCardHeader>
    <div className='row'>
        <div className='col-md-12'>
        <div className="main-dd" style={{minHeight:"35px"}}>
      <div className="name nameDashbod">
         <h4>Good Morning, <strong>Vinod Kumar Vijay</strong></h4>
         <CDropdown className="c-header-nav-items mx-2 linkOption" direction="down">
      <CDropdownToggle className="c-header-nav-link px-0" caret={false}>
        <div className="c-avatar">
         <div className='' style={{flexShrink:0, textAlign:"right", marginRight:10}}>
            <p className='mb-0'><span className='d-block '>Today:</span> 
            2022-1213 To 2022-12-13</p>
         </div>
         <img src='images/calender-blue-round.svg' className='' height="40" />
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
       
        <CDropdownItem>
          <Link to="/admin-dashboard"> <strong> Today</strong></Link>
        </CDropdownItem>
        <CDropdownItem>
          <Link to="/dashboard/ChangePassword"><strong>Yesterday</strong></Link>
        </CDropdownItem>
        <CDropdownItem>
         <Link to="/dashboard/ChangePassword"><strong>Last 7 Days</strong></Link>
        </CDropdownItem>
        <CDropdownItem>
          <Link to="/dashboard/ChangePassword"><strong>Last 30 Days</strong></Link>
        </CDropdownItem>
        <CDropdownItem>
          <Link to="/dashboard/ChangePassword"><strong>This Month</strong></Link>
        </CDropdownItem>
        <CDropdownItem>
          <Link to="/dashboard/ChangePassword"><strong>Custome Range</strong></Link>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
      </div>
     </div>
        </div>
      
    </div>
   
      </CCardHeader>

         <div className='cardHdng w-100 bg-white'>
  <div className='row'>
    <div className='col-md-5'>
        <h5 className='hdngMn'>HR 360 View Dashbaord</h5>
    </div>
    <div className='col-md-7 '>
        <div className='btnBox text-right'>
            <a href='#' >Workforce Overview</a>
            <a href='#' >Time & Attendance</a>
            <a href='#' className='active'>Headcount</a>
        </div>
    </div>
  </div>
   </div>

   <div className='cardHdng w-100 p-0 py-2'>
  <div className='row'>
    <div className='col-md-8'>
       <div className='bg-white w-100 py-3 px-3 h-100'>
<div className='d-flex ' style={{justifyContent:"space-between"}}>
<h6 class="subHdngg">Headcount: FTE/Part-Timers</h6>
<div className='d-flex countValu'>
<p><span className='grnB'></span> FTEs</p>
<p><span className='redB'></span> Part-Timers</p>
</div>
</div>
<div className='d-flex align-items-center position-relative pl-5'>
<span className='btnTag'>Result</span>
<div className='grphBox pr-3'>
<div className='w-100'>
    <img src="../images/employeet-graph.svg"  className='w-100'/>
</div>
</div>
<div className='contentBxoxx'>
<div className='contentpre text-center py-4'>
   <div className='d-flex w-100 align-items-center justify-content-center'>
        <h2>50%  </h2>
        <div className='lottieB lottieC'>
    <Lottie
      loop
      animationData={lottieJson2}
      play
      style={{ height: 50 }}
    />
    </div>
    </div>
        <p className=''> <span className='textRed'>FTEs Lower</span><br/> Then Last Month</p>
       
        <a href='#' className='btnRond'>Download Report</a>
    </div>
</div>

</div>

       </div>
    </div>
    <div className='col-md-4'>
    <div className='bg-white w-100 p-3 h-100'>
    <h6 class="subHdngg">Illness By Department</h6>
    
    <div className='contentpre'>
        <p>People Out Ill Over a Month Period</p>
   <div className='' style={{width:"85%"}}>
    <img src="images/g5.svg" className='w-100'/>
   </div>
  
    </div>
       </div>
    </div>
  </div>
   </div>


   <div className='cardHdng w-100 p-0 py-2'>
  <div className='row'>
    <div className='col-md-8'>
       <div className='bg-white w-100 py-3 px-3 h-100'>
<div className='d-flex ' style={{justifyContent:"space-between"}}>
<h6 class="subHdngg">Leavers</h6>
<div className='d-flex countValu'>
<p><span className='bluB'></span> Actual</p>
<p><span className='orgB'></span> Planned</p>
</div>
</div>
<div className='d-flex align-items-center position-relative pl-5'>
<span className='btnTag'>Cause</span>
<div className='w-100'>
    <img src="images/g4.jpeg"  className='w-100'/>
</div>
</div>

       </div>
    </div>
    <div className='col-md-4'>
       <div className='bg-white w-100 p-3 h-100'>
    <h6 class="subHdngg">Leavers Score</h6>
    
    <div className='contentpre text-center py-4'>
   <div className='d-flex w-100 align-items-center justify-content-center'>
        <h2>9  </h2>
        <div className='lottieB lottieA'>
    <Lottie
      loop
      animationData={lottieJson}
      play
      style={{ height: 50 }}
    />
    </div>
   
      
        </div>
        <p>People Who Left This</p>
        <hr/>
        <div className='d-flex w-100 align-items-center justify-content-center mb-3'>
      <div>
        <h5>10</h5>
        <p>People Expected</p>
      </div>
      <h6 className='px-4'>VS.</h6>
      <div>
        <h5>7</h5>
        <p>People Actual</p>
      </div>
        </div>
        <a href='#' className='btnRond'>Download Report</a>
    </div>
       </div>
    </div>
  </div>
   </div>

  <div className='cardHdng w-100 p-0 py-2'>
  <div className='row'>
    <div className='col-md-8'>
       <div className='bg-white w-100 py-3 px-3 h-100'>
<div className='d-flex ' style={{justifyContent:"space-between"}}>
<h6 class="subHdngg">New-Hires</h6>
<div className='d-flex countValu'>
<a href='#' className='btnRond'>Download Report</a>
</div>
</div>
<div className='d-flex align-items-center position-relative pl-5 mt-2'>
<span className='btnTag'>Effect</span>
<div className='w-100'>
    <img src="images/g6.svg"  className='w-100'/>
</div>
</div>

       </div>
    </div>
    <div className='col-md-4'>
    <div className='bg-white w-100 py-3 px-3 h-100'>
<div className='d-flex ' style={{justifyContent:"space-between"}}>
<h6 class="subHdngg">New-Hires: Key Positions</h6>
</div>
<div className='w-100 d-flex align-items-center'>
    <div className='courseBox'>
<div className='d-flex align-items-center position-relative mt-3'>

<div className='w-100'>
    <img src="images/g3.svg"  className='w-100'/>
   <p className='text-center mt-1'>78% of Employees During ea. shift Working Overtime</p>
</div>
</div>
</div>
<div className='contentpre text-center py-2 contentBxx'>
  <div className='mb-3 w-100'>
      <div>
        <h2>11</h2>
        <p>Hired This Month</p>
      </div>
     
        </div>
        <a href='#' className='btnRond'>Download Report</a>
    </div>



</div>

       </div>
    </div>
  </div>
   </div>




                </main>
             </div>
             
        <TheFooter />
      </div>
    </div>
        </>)
}
export default HeadcountDashboard
